import React, { useState, useEffect } from "react";
import { Tooltip, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useLocation as useWocation, useRoute as useWoute } from "wouter";
import useHashLocation from "../hooks/useHashLocation";
import useUiStore from "../../stores/useUiStore";

import Collection from "./collection";
import TemplateMetopes from "./templateMetopes";
import TemplatePath from "./templatePath";
import { useColors } from "../hooks";

const MyTooltip = (props) => {
  const { title, children } = props;
  return (
    <Tooltip
      title={<Typography>{title}</Typography>}
      arrow
      componentsProps={{
        tooltip: {
          sx: {
            bgcolor: "common.black",
            "& .MuiTooltip-arrow": {
              color: "common.black",
            },
          },
        },
      }}
    >
      {children}
    </Tooltip>
  );
};

const Metopes = () => {
  const dataMetopes = [
    {
      id: "grandes-metopes",
      title: "Grandes métopes",
      paths: {
        architrave:
          "m 105.83333,17.774626 a 88.058929,88.058929 0 0 0 -88.058704,88.058704 88.058929,88.058929 0 0 0 88.058704,88.05871 88.058929,88.058929 0 0 0 88.05871,-88.05871 88.058929,88.058929 0 0 0 -88.05871,-88.058704 z m 0,11.171411 a 76.887276,76.887276 0 0 1 76.8873,76.887293 76.887276,76.887276 0 0 1 -76.8873,76.8873 76.887276,76.887276 0 0 1 -76.887293,-76.8873 76.887276,76.887276 0 0 1 76.887293,-76.887293 z",
        metopes:
          "m 103.03102,10.2325 -5.84376,0.9254 0.14333,0.9057 5.84375,-0.9254 z m 7.82133,-0.61555 0.00011,0.91697 5.91658,-0.00016 -0.00012,-0.91697 z M 89.55856,12.9894 l -5.62754,1.82848 0.28374,0.87184 5.62703,-1.82844 z m 35.03165,-2.75705 -0.14334,0.90546 5.84378,0.92567 0.14386,-0.9055 z m -47.90704,7.58759 -5.27182,2.68636 0.41625,0.81684 5.27186,-2.68585 z m 61.37957,-4.83068 -0.2833,0.87241 5.62711,1.82808 0.28334,-0.87189 z m -73.34067,11.61605 -4.78704,3.47811 0.53891,0.74187 4.78704,-3.47811 z m 86.21598,-6.78535 -0.41622,0.81704 5.2722,2.68643 0.41622,-0.81704 z m -96.96857,15.3583 -4.1841,4.18384 0.64873,0.64873 4.18359,-4.1838 z m 108.92988,-8.57297 -0.53874,0.74219 4.78658,3.47783 0.53925,-0.74223 z m -118.2091,18.72242 -3.47779,4.78709 0.74219,0.53874 3.47783,-4.78657 z m 128.96181,-10.14951 -0.64874,0.64873 4.1838,4.18359 0.64877,-0.64821 z M 37.11357,54.80392 l -2.68643,5.2722 0.81704,0.41622 2.68643,-5.2722 z m 145.81718,-11.47606 -0.74187,0.53891 3.47811,4.78704 0.74187,-0.53891 z m -151.50572,23.99642 -1.8286,5.62715 0.87241,0.28331 1.82808,-5.62711 z m 159.08284,-12.52009 -0.81684,0.41625 2.68585,5.27186 0.81735,-0.4163 z m -162.74272,25.77548 -0.92563,5.84429 0.90546,0.14334 0.92567,-5.84378 z m 168.43114,-13.25582 -0.87184,0.28374 1.82843,5.62703 0.87189,-0.28322 z m -169.97233,26.9214 0.00015,5.91657 0.91697,-0.00011 -0.00015,-5.91658 z m 173.63231,-13.66516 -0.9057,0.14333 0.9254,5.84376 0.9057,-0.14333 z m -172.1109,27.25973 -0.9057,0.14333 0.9254,5.84376 0.9057,-0.14334 z m 172.73488,-13.59453 0.00016,5.91657 0.91697,-0.00011 -0.00015,-5.91658 z m -170.01179,26.9271 -0.87189,0.28322 1.82848,5.62754 0.87184,-0.28374 z m 169.4079,-13.3327 -0.92566,5.84378 0.90549,0.14386 0.92563,-5.84429 z m -164.6319,26.07501 -0.81735,0.4163 2.68636,5.27181 0.81684,-0.41625 z m 161.90804,-12.74244 -1.82808,5.62711 0.87189,0.28335 1.8286,-5.62715 z m -155.19815,24.58093 -0.74187,0.53891 3.47811,4.78703 0.74187,-0.5389 z m 150.42281,-11.83853 -2.68643,5.27219 0.81704,0.41622 2.68643,-5.27219 z m -141.94295,22.48181 -0.64877,0.64822 4.18384,4.1841 0.64873,-0.64873 z m 135.23247,-10.64302 -3.47783,4.78657 0.74223,0.53926 3.47779,-4.78709 z m -125.19253,19.82823 -0.53926,0.74223 4.78709,3.47779 0.53874,-0.74219 z m 116.71309,-9.18552 -4.18359,4.1838 0.64821,0.64877 4.18411,-4.18384 z m -105.35993,16.6874 -0.41622,0.81704 5.2722,2.68643 0.41622,-0.81704 z m 95.32009,-7.50185 -4.78704,3.4781 0.53891,0.74187 4.78704,-3.47811 z m -82.9326,13.13553 -0.28335,0.8719 5.62715,1.8286 0.28331,-0.87241 z m 71.57893,-5.63338 -5.27185,2.68585 0.41629,0.81735 5.27182,-2.68637 z m -58.46303,9.25966 -0.14386,0.9055 5.84429,0.92562 0.14334,-0.90545 z m 46.0759,-3.62625 -5.62703,1.82844 0.28322,0.87188 5.62754,-1.82848 z m -32.55428,5.15596 0.00011,0.91698 5.91658,-0.00016 -0.00012,-0.91697 z m 19.43844,-1.52984 -5.84376,0.92541 0.14334,0.9057 5.84375,-0.9254 z",
      },
    },
    {
      id: "petites-metopes",
      title: "Petites métopes",
      paths: {
        architrave:
          "m 105.83333,53.260832 a 52.572498,52.572498 0 0 0 -52.572498,52.572498 52.572498,52.572498 0 0 0 52.572498,52.5725 52.572498,52.572498 0 0 0 52.5725,-52.5725 52.572498,52.572498 0 0 0 -52.5725,-52.572498 z m 0,8.651668 a 43.920834,43.920834 0 0 1 43.92084,43.92083 43.920834,43.920834 0 0 1 -43.92084,43.92084 A 43.920834,43.920834 0 0 1 61.9125,105.83333 43.920834,43.920834 0 0 1 105.83333,61.9125 Z",
        metopes:
          "m 107.58017,45.693819 -3.76097,0.596127 0.12602,0.797691 3.76152,-0.595652 z m 4.32641,-0.340495 -1.6e-4,0.808139 3.8084,-1.14e-4 -3.6e-4,-0.808099 z m -12.307494,1.949362 -3.62194,1.177154 0.249666,0.768262 3.62198,-1.17664 z m 20.441994,-1.60882 -0.12637,0.798374 3.76146,0.59555 0.12641,-0.797859 z m -28.073393,4.446675 -3.39295,1.728813 0.366619,0.719662 3.393465,-1.728854 z m 36.054783,-2.837572 -0.25004,0.768194 3.62213,1.176713 0.24953,-0.768154 z m -43.148203,6.833615 -3.080683,2.238668 0.474941,0.653598 3.080724,-2.238152 z m 50.779403,-3.996426 -0.36681,0.720364 3.39292,1.728666 0.36685,-0.719848 z m -57.160031,9.053442 -2.692972,2.692823 0.571622,0.571345 2.692457,-2.692783 z m 64.253201,-5.056837 -0.4747,0.653692 3.08056,2.238437 0.4752,-0.653732 z m -69.764505,11.049503 -2.238396,3.081067 0.653691,0.474691 2.238437,-3.080552 z m 76.145415,-5.992774 -0.57135,0.571622 2.69278,2.692457 0.57139,-0.571107 z m -80.651235,12.774045 -1.729181,3.392959 0.720363,0.366808 1.728666,-3.392919 z m 86.162405,-6.781128 -0.6536,0.474941 2.23815,3.080723 0.65411,-0.474981 z m -89.552022,14.183671 -1.176754,3.621623 0.768194,0.250041 1.176713,-3.622138 z m 94.057912,-7.402518 -0.71966,0.366619 1.72886,3.393465 0.71962,-0.367135 z M 62.897106,87.21159 62.301041,90.973085 63.099415,91.099454 63.694966,87.338 Z m 99.637224,-7.841619 -0.76826,0.249665 1.17664,3.621981 0.76877,-0.249706 z m -100.573905,15.929736 7.4e-5,3.807884 0.808139,1.56e-4 -1.14e-4,-3.808398 z m 102.763795,-8.087686 -0.79769,0.12602 0.59565,3.761529 0.79817,-0.126576 z m -101.62506,16.095399 -0.798165,0.12658 0.596127,3.76097 0.79769,-0.12602 z m 101.75355,-8.008174 1.1e-4,3.808399 0.8081,-3.59e-4 -7e-5,-3.807883 z m -100.174072,15.866134 -0.768777,0.2497 1.177154,3.62194 0.768262,-0.24966 z m 99.843292,-7.85784 -0.59555,3.76145 0.79786,0.12641 0.59606,-3.76149 z m -97.054592,15.37181 -0.719621,0.36713 1.728812,3.39295 0.719662,-0.36662 z m 95.475672,-7.5141 -1.17672,3.62214 0.76816,0.24952 1.17675,-3.62162 z m -91.545137,14.49967 -0.654114,0.47498 2.238669,3.08069 0.653598,-0.47495 z m 88.755777,-6.98523 -1.72867,3.39292 0.71985,0.36685 1.72918,-3.39296 z m -83.781489,13.26973 -0.571386,0.57111 2.692823,2.69297 0.571345,-0.57162 z m 79.851549,-6.28445 -2.23843,3.08055 0.65373,0.47521 2.2384,-3.08107 z m -73.955063,11.71313 -0.475206,0.65373 3.081068,2.2384 0.474691,-0.65369 z m 68.980413,-5.42887 -2.69246,2.69278 0.5711,0.57138 2.69298,-2.69282 z m -62.307499,9.86858 -0.366849,0.71984 3.39296,1.72919 0.366808,-0.72037 z m 56.411259,-4.43967 -3.08072,2.23816 0.47498,0.65411 3.08068,-2.23867 z m -49.126079,7.78046 -0.249486,0.76867 3.621623,1.17675 0.250041,-0.76819 z m 42.453249,-3.34062 -3.39347,1.72885 0.36714,0.71962 3.39295,-1.72881 z m -34.73482,5.50122 -0.1264,0.79786 3.76149,0.59607 0.12637,-0.79838 z m 27.44936,-2.16031 -3.62198,1.17664 0.24971,0.76878 3.62194,-1.17716 z m -7.71844,2.15995 -3.76149,0.59617 0.12657,0.79816 3.76098,-0.59612 z m -11.76957,0.9268 3.6e-4,0.8081 3.80789,-7e-5 1.5e-4,-0.80814 z",
      },
    },
  ];

  return dataMetopes.map((m, i) => (
    <TemplateMetopes key={i} {...m} MyTooltip={MyTooltip} />
  ));
};

const Acroteres = () => {
  const [hovered, setHovered] = useState(false);
  const [selected, setSelected] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const [loc] = useWocation();
  const [locHash] = useHashLocation();

  const { palette } = useTheme();

  const paramsTexte = useUiStore((state) => state.paramsTexte);

  const fill = hovered ? "orange" : selected ? "peru" : palette.text.disabled;

  const handleClick = () => {
    navigate(`/tholos/acroteres`);
    useUiStore.setState({
      paramsTexte: { ...paramsTexte, currentTexte: "acroteres" },
    });
  };

  const handleMouseOver = (e) => {
    e.stopPropagation();
    setHovered(true);
  };
  const handleMouseOut = (e) => {
    e.stopPropagation();
    setHovered(false);
  };

  useEffect(() => {
    let path = import.meta.env.VITE_NODE_ENV === "production" ? locHash : loc;

    if (path === "/tholos/acroteres") {
      setSelected(true);
    } else {
      setSelected(false);
    }
  }, [loc, location, locHash]);

  return (
    <MyTooltip title="Acrotères">
      <g
        id="acroteres"
        onClick={handleClick}
        onMouseOver={handleMouseOver}
        onMouseOut={handleMouseOut}
      >
        <path
          className="acroteres"
          id="acroteres"
          stroke={palette.text.primary}
          fill={fill}
          d="M 104.09029 19.604488 C 103.28165 19.604488 102.63094 20.255708 102.63094 21.064347 L 102.63094 25.872839 C 102.63094 26.681478 103.28165 27.332699 104.09029 27.332699 L 107.57638 27.332699 C 108.38502 27.332699 109.03572 26.681478 109.03572 25.872839 L 109.03572 21.064347 C 109.03572 20.255708 108.38502 19.604488 107.57638 19.604488 L 104.09029 19.604488 z M 81.27876 23.214087 C 81.135056 23.21607 80.988877 23.239581 80.844678 23.286434 L 77.529635 24.363371 C 76.760573 24.613254 76.342341 25.433474 76.592224 26.202535 L 78.078438 30.775899 C 78.328321 31.544961 79.148541 31.963193 79.917603 31.71331 L 83.232646 30.635856 C 84.001707 30.385973 84.419939 29.565753 84.170056 28.796692 L 82.683842 24.223328 C 82.480812 23.598465 81.901478 23.205494 81.27876 23.214087 z M 130.38791 23.214087 C 129.76519 23.205494 129.18585 23.598465 128.98282 24.223328 L 127.49661 28.796692 C 127.24673 29.565753 127.66496 30.385973 128.43402 30.635856 L 131.74906 31.71331 C 132.51813 31.963193 133.33835 31.544961 133.58823 30.775899 L 135.07444 26.202535 C 135.32433 25.433474 134.90609 24.613254 134.13703 24.363371 L 130.82199 23.286434 C 130.67779 23.239581 130.53161 23.21607 130.38791 23.214087 z M 57.366524 34.768937 C 57.085788 34.778747 56.804664 34.870267 56.559338 35.048507 L 53.739355 37.097477 C 53.085153 37.572783 52.941072 38.48191 53.416378 39.136112 L 56.243079 43.026314 C 56.718385 43.680517 57.627511 43.824598 58.281714 43.349292 L 61.101697 41.300321 C 61.755899 40.825015 61.899981 39.915889 61.424674 39.261686 L 58.597974 35.371484 C 58.300907 34.962608 57.834418 34.752588 57.366524 34.768937 z M 154.30014 34.768937 C 153.83225 34.752588 153.36576 34.962608 153.06869 35.371484 L 150.24199 39.261686 C 149.76669 39.915889 149.91077 40.825015 150.56497 41.300321 L 153.38495 43.349292 C 154.03916 43.824598 154.94828 43.680517 155.42359 43.026314 L 158.25029 39.136112 C 158.72559 38.48191 158.58151 37.572783 157.92731 37.097477 L 155.10733 35.048507 C 154.862 34.870267 154.58088 34.778747 154.30014 34.768937 z M 38.328927 53.137325 C 37.861033 53.120976 37.394543 53.330479 37.097477 53.739355 L 35.048507 56.559338 C 34.573201 57.213541 34.717282 58.122668 35.371484 58.597974 L 39.261686 61.424674 C 39.915889 61.899981 40.825015 61.755899 41.300321 61.101697 L 43.349292 58.281714 C 43.824598 57.627511 43.680517 56.718385 43.026314 56.243079 L 39.136112 53.416378 C 38.890786 53.238138 38.609663 53.147135 38.328927 53.137325 z M 173.33774 53.137325 C 173.057 53.147135 172.77588 53.238138 172.53055 53.416378 L 168.64035 56.243079 C 167.98615 56.718385 167.84207 57.627511 168.31737 58.281714 L 170.36635 61.101697 C 170.84165 61.755899 171.75078 61.899981 172.40498 61.424674 L 176.29518 58.597974 C 176.94938 58.122668 177.09347 57.213541 176.61816 56.559338 L 174.56919 53.739355 C 174.27212 53.330479 173.80563 53.120976 173.33774 53.137325 z M 25.76897 76.520394 C 25.146252 76.511801 24.566401 76.904772 24.363371 77.529635 L 23.286434 80.844678 C 23.036551 81.613739 23.454266 82.433959 24.223328 82.683842 L 28.796692 84.170056 C 29.565753 84.419939 30.385973 84.001707 30.635856 83.232646 L 31.71331 79.917603 C 31.963193 79.148541 31.544961 78.328321 30.775899 78.078438 L 26.202535 76.592224 C 26.058336 76.545371 25.912674 76.522377 25.76897 76.520394 z M 185.8977 76.520394 C 185.75399 76.522377 185.60833 76.545371 185.46413 76.592224 L 180.89077 78.078438 C 180.12171 78.328321 179.70347 79.148541 179.95336 79.917603 L 181.03081 83.232646 C 181.28069 84.001707 182.10091 84.419939 182.86997 84.170056 L 187.44334 82.683842 C 188.2124 82.433959 188.63012 81.613739 188.38023 80.844678 L 187.3033 77.529635 C 187.10027 76.904772 186.52042 76.511801 185.8977 76.520394 z M 21.064347 102.63094 C 20.255708 102.63094 19.604488 103.28165 19.604488 104.09029 L 19.604488 107.57638 C 19.604488 108.38502 20.255708 109.03572 21.064347 109.03572 L 25.872839 109.03572 C 26.681478 109.03572 27.332699 108.38502 27.332699 107.57638 L 27.332699 104.09029 C 27.332699 103.28165 26.681478 102.63094 25.872839 102.63094 L 21.064347 102.63094 z M 185.79383 102.63094 C 184.98519 102.63094 184.33397 103.28165 184.33397 104.09029 L 184.33397 107.57638 C 184.33397 108.38502 184.98519 109.03572 185.79383 109.03572 L 190.60232 109.03572 C 191.41096 109.03572 192.06218 108.38502 192.06218 107.57638 L 192.06218 104.09029 C 192.06218 103.28165 191.41096 102.63094 190.60232 102.63094 L 185.79383 102.63094 z M 29.230774 127.42426 C 29.08707 127.42625 28.940891 127.44976 28.796692 127.49661 L 24.223328 128.98282 C 23.454266 129.23271 23.036551 130.05293 23.286434 130.82199 L 24.363371 134.13703 C 24.613254 134.90609 25.433474 135.32433 26.202535 135.07444 L 30.775899 133.58823 C 31.544961 133.33835 31.963193 132.51813 31.71331 131.74906 L 30.635856 128.43402 C 30.432826 127.80916 29.853492 127.41567 29.230774 127.42426 z M 182.43589 127.42426 C 181.81317 127.41567 181.23384 127.80916 181.03081 128.43402 L 179.95336 131.74906 C 179.70347 132.51813 180.12171 133.33835 180.89077 133.58823 L 185.46413 135.07444 C 186.23319 135.32433 187.05341 134.90609 187.3033 134.13703 L 188.38023 130.82199 C 188.63012 130.05293 188.2124 129.23271 187.44334 128.98282 L 182.86997 127.49661 C 182.72578 127.44976 182.5796 127.42625 182.43589 127.42426 z M 40.068872 149.96294 C 39.788136 149.97275 39.507012 150.06375 39.261686 150.24199 L 35.371484 153.06869 C 34.717282 153.544 34.573201 154.45313 35.048507 155.10733 L 37.097477 157.92731 C 37.572783 158.58151 38.48191 158.72559 39.136112 158.25029 L 43.026314 155.42359 C 43.680517 154.94828 43.824598 154.03916 43.349292 153.38495 L 41.300321 150.56497 C 41.003255 150.15609 40.536766 149.94659 40.068872 149.96294 z M 171.59779 149.96294 C 171.1299 149.94659 170.66341 150.15609 170.36635 150.56497 L 168.31737 153.38495 C 167.84207 154.03916 167.98615 154.94828 168.64035 155.42359 L 172.53055 158.25029 C 173.18476 158.72559 174.09388 158.58151 174.56919 157.92731 L 176.61816 155.10733 C 177.09347 154.45313 176.94938 153.544 176.29518 153.06869 L 172.40498 150.24199 C 172.15965 150.06375 171.87853 149.97275 171.59779 149.96294 z M 57.474528 168.03832 C 57.006635 168.02197 56.540145 168.23148 56.243079 168.64035 L 53.416378 172.53055 C 52.941072 173.18476 53.085153 174.09388 53.739355 174.56919 L 56.559338 176.61816 C 57.213541 177.09347 58.122668 176.94938 58.597974 176.29518 L 61.424674 172.40498 C 61.899981 171.75078 61.755899 170.84165 61.101697 170.36635 L 58.281714 168.31737 C 58.036388 168.13913 57.755264 168.04813 57.474528 168.03832 z M 154.19214 168.03832 C 153.9114 168.04813 153.63028 168.13913 153.38495 168.31737 L 150.56497 170.36635 C 149.91077 170.84165 149.76669 171.75078 150.24199 172.40498 L 153.06869 176.29518 C 153.544 176.94938 154.45313 177.09347 155.10733 176.61816 L 157.92731 174.56919 C 158.58151 174.09388 158.72559 173.18476 158.25029 172.53055 L 155.42359 168.64035 C 155.12652 168.23148 154.66003 168.02197 154.19214 168.03832 z M 79.483521 179.88101 C 78.860802 179.87242 78.281468 180.26591 78.078438 180.89077 L 76.592224 185.46413 C 76.342341 186.23319 76.760573 187.05341 77.529635 187.3033 L 80.844678 188.38023 C 81.613739 188.63012 82.433959 188.2124 82.683842 187.44334 L 84.170056 182.86997 C 84.419939 182.10091 84.001707 181.28069 83.232646 181.03081 L 79.917603 179.95336 C 79.773404 179.9065 79.627225 179.88299 79.483521 179.88101 z M 132.18315 179.88101 C 132.03944 179.88299 131.89326 179.9065 131.74906 179.95336 L 128.43402 181.03081 C 127.66496 181.28069 127.24673 182.10091 127.49661 182.86997 L 128.98282 187.44334 C 129.23271 188.2124 130.05293 188.63012 130.82199 188.38023 L 134.13703 187.3033 C 134.90609 187.05341 135.32433 186.23319 135.07444 185.46413 L 133.58823 180.89077 C 133.3852 180.26591 132.80586 179.87242 132.18315 179.88101 z M 104.09029 184.33397 C 103.28165 184.33397 102.63094 184.98519 102.63094 185.79383 L 102.63094 190.60232 C 102.63094 191.41096 103.28165 192.06218 104.09029 192.06218 L 107.57638 192.06218 C 108.38502 192.06218 109.03572 191.41096 109.03572 190.60232 L 109.03572 185.79383 C 109.03572 184.98519 108.38502 184.33397 107.57638 184.33397 L 104.09029 184.33397 z "
        >
          {/* <title>Acrotères</title> */}
        </path>
      </g>
    </MyTooltip>
  );
};

const Fleuron = () => {
  return (
    <g id="fleuron" className="fleuron">
      <circle id="fleuron-ext" r="7.7681193" cy="105.83334" cx="105.83334" />
      <circle id="fleuron-int" r="3.7532465" cy="105.83334" cx="105.83334" />
    </g>
  );
};

const Colonne = () => {
  return (
    <g id="colonne">
      <rect
        id="base"
        y="17.517586"
        x="99.882378"
        height="11.901915"
        width="11.901915"
      />
      <circle cx="105.83334" cy="23.468544" r="4.4971786" />
    </g>
  );
};

const Crepis = () => {
  const navigate = useNavigate();
  const [hovered, setHovered] = useState(false);
  const paramsTexte = useUiStore((state) => state.paramsTexte);

  const { crepis } = useColors();

  const handleClick = () => {
    navigate(`/tholos`);
    useUiStore.setState({
      paramsTexte: { ...paramsTexte, currentTexte: "elements" },
    });
  };
  const handleMouseOver = (e) => {
    e.stopPropagation();
    setHovered(true);
  };
  const handleMouseOut = (e) => {
    e.stopPropagation();
    setHovered(false);
  };

  const fill = hovered ? crepis.fill.hovered : crepis.fill.idle;

  // 'text.primary'

  return (
    <MyTooltip title="Retour Tholos">
      <g
        id="crepis"
        className="crepis"
        onClick={handleClick}
        onMouseOver={handleMouseOver}
        onMouseOut={handleMouseOut}
        fill={fill}
      >
        <circle
          cx="105.83334"
          cy="105.83334"
          //   r="76.887276"
          r="88.058929"
        />
        {/* <title>Retour Tholos</title> */}
      </g>
    </MyTooltip>
  );
};

const Peristyle = () => {
  return (
    <g id="peristyle" className="crepis">
      <path d="M 105.83333 28.946037 A 76.887276 76.887276 0 0 0 28.946037 105.83333 A 76.887276 76.887276 0 0 0 105.83333 182.72063 A 76.887276 76.887276 0 0 0 182.72063 105.83333 A 76.887276 76.887276 0 0 0 105.83333 28.946037 z M 105.83333 53.260832 A 52.572498 52.572498 0 0 1 158.40583 105.83333 A 52.572498 52.572498 0 0 1 105.83333 158.40583 A 52.572498 52.572498 0 0 1 53.260832 105.83333 A 52.572498 52.572498 0 0 1 105.83333 53.260832 z " />
    </g>
  );
};

const Cella = () => {
  const handleClick = () => {
    console.log("click cella");
  };

  return (
    <g id="cella" className="crepis">
      <circle
        cx="105.83334"
        cy="105.83334"
        r="43.920834"
        onClick={handleClick}
      />
    </g>
  );
};

const Tholos = () => {
  return (
    <g id="cella" className="crepis">
      <path d="M 105.83333 28.946037 A 76.887276 76.887276 0 0 0 28.946037 105.83333 A 76.887276 76.887276 0 0 0 105.83333 182.72063 A 76.887276 76.887276 0 0 0 182.72063 105.83333 A 76.887276 76.887276 0 0 0 105.83333 28.946037 z M 105.83333 53.260832 A 52.572498 52.572498 0 0 1 158.40583 105.83333 A 52.572498 52.572498 0 0 1 105.83333 158.40583 A 52.572498 52.572498 0 0 1 53.260832 105.83333 A 52.572498 52.572498 0 0 1 105.83333 53.260832 z " />
      <circle cx="105.83334" cy="105.83334" r="43.920834" />
    </g>
  );
};

const Outils = () => {
  const data = {
    id: "outils",
    path: "m 118.22264,108.83737 c -0.008,-0.10912 -0.0824,-0.20269 -0.18649,-0.24011 -0.10447,-0.0376 -0.221,-0.0116 -0.29958,0.0653 l -1.6058,1.58342 -1.78018,-0.55584 -0.56366,-1.75542 1.60584,-1.58351 c 0.0786,-0.0775 0.10411,-0.1926 0.0664,-0.29532 -0.0383,-0.10295 -0.13301,-0.17453 -0.24383,-0.18391 -0.97526,-0.0828 -1.93082,0.26049 -2.62168,0.94185 -0.94621,0.93316 -1.19678,2.29581 -0.75307,3.4573 -0.0486,0.0404 -0.0964,0.0831 -0.1436,0.12909 l -5.36026,4.98773 c -0.001,10e-4 -0.005,0.005 -0.005,0.005 -0.6304,0.62166 -0.6304,1.63316 0,2.25489 0.63048,0.62161 1.6487,0.61405 2.27899,-0.007 0.003,-0.002 0.005,-0.005 0.007,-0.007 l 5.01386,-5.32696 c 0.0457,-0.0452 0.0882,-0.0927 0.12808,-0.14128 1.17814,0.43837 2.56088,0.19192 3.50791,-0.74191 0.69073,-0.68143 1.03916,-1.62378 0.95504,-2.58532 z m -10.42041,8.13932 c -0.23225,0.22897 -0.6085,0.22897 -0.84074,0 -0.23225,-0.22873 -0.23225,-0.6001 0,-0.82897 0.23224,-0.22897 0.60845,-0.22897 0.84074,0 0.23227,0.22897 0.23227,0.60018 0,0.82897 z",
    title: "outils",
    translation: { x: 93, y: 2 },
  };

  return <TemplatePath {...data} MyTooltip={MyTooltip} />;
};

const fragments = {
  id: "fragments",
  title: "Fragments",
  translation: { x: 171, y: 172 },
  size: { width: 3, height: 3 },
  shift: { width: 6, height: 6 },
  positions: [
    { x: 0, y: 0 },
    { x: 0, y: 1 },
    { x: 1, y: 0 },
    { x: 2, y: 0 },
    { x: 1, y: 1 },
    { x: 2, y: 1 },
    { x: 0, y: 2 },
    { x: 1, y: 2 },
    { x: 2, y: 2 },
    { x: -1, y: 2 },
    { x: -2, y: 2 },
    { x: -1, y: 1 },
    { x: 2, y: -1 },
    { x: 2, y: -2 },
    { x: 1, y: -1 },
  ],
  radius: 0.5,
};

const petitesMetopes = {
  id: "petites-metopes",
  title: "Petites métopes",
  translation: { x: 144, y: 191 },
  size: { width: 7, height: 7 },
  shift: { width: 10, height: 10 },
  positions: [
    { x: 0, y: 0 },
    { x: 1, y: 0 },
    { x: 2, y: 0 },
    { x: 3, y: 0 },
    { x: 4, y: 0 },
    { x: 5, y: 0 },
    { x: 6, y: 0 },
  ],
  radius: 0.5,
};

const grandesMetopes = {
  id: "grandes-metopes",
  title: "Grandes métopes",
  translation: { x: 190, y: 154 },
  size: { width: 9, height: 9 },
  shift: { width: 12, height: 12 },
  positions: [
    { x: 0, y: 0 },
    { x: 0, y: 1 },
    { x: 1, y: 0 },
    { x: 1, y: 1 },
    { x: 0, y: 2 },
    { x: 1, y: 2 },
  ],
  radius: 0.5,
};

const fragmentsAcroteres = {
  id: "acroteres",
  title: "Acrotères",
  translation: { x: 202, y: 130 },
  size: { width: 9, height: 20 },
  shift: { width: 0, height: 0 },
  positions: [{ x: 0, y: 0 }],
  radius: 2.5,
};

const FragmentsAcroteres = () => {
  return <Collection {...fragmentsAcroteres} />;
};

const Fragments = () => {
  return <Collection {...fragments} />;
};

const PetitesMetopes = () => {
  return <Collection {...petitesMetopes} />;
};

const GrandesMetopes = () => {
  return <Collection {...grandesMetopes} />;
};

export {
  Metopes,
  Acroteres,
  Colonne,
  Fleuron,
  Crepis,
  Cella,
  Peristyle,
  Tholos,
  Fragments,
  PetitesMetopes,
  GrandesMetopes,
  FragmentsAcroteres,
  Outils,
};
